//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_epsilon6 = 0.000001;\n\
";
